const METADATA_FIELD_PREFIX = 'metadata.';
const FIELD_SEPARATOR = '.';
const LABEL_SEPARATOR = ' - ';

export const toTitleCase = (field: string) => {
  return field
    .replace(/[0-9]{2,}/g, (match) => ` ${match} `)
    .replace(/[^A-Z0-9][A-Z]/g, (match) => `${match[0]} ${match[1]}`)
    .replace(/[A-Z][A-Z][^A-Z0-9]/g, (match) => `${match[0]} ${match[1]}${match[2]}`)
    .replace(/[ ]{2,}/g, (match) => ' ')
    .replace(/\s./g, (match) => match.toUpperCase())
    .replace(/^./, (match) => match.toUpperCase())
    .trim();
};

export const getFieldTitle = (field: string, jsonSchema?: any) => {
  return field.includes(METADATA_FIELD_PREFIX)
    ? getMetadataFieldTitle(field, jsonSchema)
    : getOtherFieldTitle(field);
};

const getMetadataFieldTitle = (metadataField: string, jsonSchema: any) => {
  const field = metadataField.replace(METADATA_FIELD_PREFIX, '');
  return jsonSchema && jsonSchema.properties && jsonSchema.properties[field] && jsonSchema.properties[field].title
    ? toTitleCase(`${METADATA_FIELD_PREFIX.replace(FIELD_SEPARATOR, LABEL_SEPARATOR)}${jsonSchema.properties[field].title}`)
    : toTitleCase(`${METADATA_FIELD_PREFIX.replace(FIELD_SEPARATOR, LABEL_SEPARATOR)}${field}`);
};

const getOtherFieldTitle = (contentField: string) => {
  return toTitleCase(`${contentField.replaceAll(FIELD_SEPARATOR, LABEL_SEPARATOR)}`);
};
